import { Component, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToolbarComponent } from '../../core/layout/components/toolbar/toolbar.component';
import { FooterComponent } from '../../core/layout/components/footer/footer.component';
import { SpinnerComponent } from '../../shared/components/spinner/spinner.component';
import { AzSearchbarComponent } from '../../shared/components/az-searchbar/az-searchbar.component';
import {
  AzTableComponent,
  AzTableColumn,
} from '../../shared/components/az-table/az-table.component';
import { AzButtonComponent } from '../../shared/components/az-button/az-button.component';
import { StatusChangeModalComponent } from '../../shared/components/status-change-modal/status-change-modal.component';
import { SignatoryService } from './services/signatory.service';
import { SignatoryEntry } from './models/signatory-entry.model';
import { LoggerService } from '../../core/logging/logger.service';

@Component({
  selector: 'app-signatory-list',
  standalone: true,
  imports: [
    CommonModule,
    ToolbarComponent,
    FooterComponent,
    SpinnerComponent,
    AzSearchbarComponent,
    AzTableComponent,
    AzButtonComponent,
    StatusChangeModalComponent,
  ],
  templateUrl: './signatory-list.component.html',
  styleUrl: './signatory-list.component.scss',
})
export class SignatoryListComponent implements OnInit {
  loading = signal(false);
  loadError = signal<string | null>(null);
  searchText = signal<string>('');
  isDownloading = signal(false);

  allRows: SignatoryEntry[] = [];

  columns: AzTableColumn[] = [
    { key: 'companyName', label: 'Company Name', width: '26.06%' },
    { key: 'address', label: 'Address', width: '53.52%' },
    { key: 'companyRegistrationNumber', label: 'Company Registration Number', width: '20.42%' },
  ];

  constructor(
    private signatoryService: SignatoryService,
    private logger: LoggerService,
  ) {}

  ngOnInit(): void {
    this.logger.info('Signatory List page loaded');
    this.loadSignatories();
  }

  private loadSignatories(): void {
    this.loading.set(true);
    this.loadError.set(null);
    this.signatoryService.getSignatories().subscribe({
      next: (rows) => {
        this.allRows = rows;
        this.loading.set(false);
      },
      error: (err) => {
        this.logger.error('Failed to load signatory list', err);
        this.loadError.set('Failed to load signatory list. Please try again.');
        this.loading.set(false);
      },
    });
  }

  displayRows(): SignatoryEntry[] {
    const q = this.searchText().toLowerCase().trim();
    if (!q) return this.allRows;
    return this.allRows.filter(
      (row) =>
        row.companyName.toLowerCase().includes(q) ||
        row.address.toLowerCase().includes(q) ||
        row.companyRegistrationNumber.toLowerCase().includes(q),
    );
  }

  onSearchChange(value: string): void {
    this.searchText.set(value);
  }

  onDownload(): void {
    if (this.isDownloading()) return;
    this.isDownloading.set(true);
    this.signatoryService.downloadPdf().subscribe({
      next: (blob) => {
        this.signatoryService.triggerBlobDownload(blob, 'signatory-list.pdf');
        this.isDownloading.set(false);
      },
      error: (err) => {
        this.logger.error('Failed to download signatory list PDF', err);
        this.isDownloading.set(false);
      },
    });
  }
}
